import React, { Component, Suspense, Fragment } from 'react';
import config from './../../../config/config.json';
import ContentLoader from "react-content-loader";
import { IconButton, Collapse, Container, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import { withRouter } from 'react-router-dom';

class DashboardCardExpanded extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			userData: {},
			statusLogin: false,
			card: [],
			alertData: null // Local backup of alert data
		}
	}

	UNSAFE_componentWillMount = async () => {
		//Come from routing dinamic
		let card = this.props.match.params.card;
		let cardFilter = config.cards.filter(e => e.routing === card);
		this.setState({ statusLogin: false, card: cardFilter[0] });

		// Initial check for alerts on mount
		this.checkAlertTimeout();
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			this.checkAlertTimeout();
		}
	}

	componentWillUnmount() {
		if (this.alertTimeout) {
			clearTimeout(this.alertTimeout);
		}
	}

	checkAlertTimeout = () => {
		const { location, history } = this.props;

		// If we have state in location, we backup it locally and CLEAN history immediately
		if (location.state && (location.state.responseCreate || location.state.responseEdit || location.state.responseDelete)) {

			this.setState({
				alertData: { ...location.state },
				open: true
			});

			// CRITICAL: Clear history state so it doesn't reappear on reload
			history.replace(location.pathname, null);

			if (this.alertTimeout) clearTimeout(this.alertTimeout);
			this.alertTimeout = setTimeout(() => {
				this.setState({ open: false });
			}, 5000);
		}
	}

	dashboardCardType = () => {
		console.log("dashboardCardType: ", this.state.card.config.type)
		let Component = React.lazy(() => import(`./sections/DashboardCard${this.state.card.config.type}`));
		return <Suspense fallback={<div className="preload"><div className="responsive">
			<ContentLoader speed={2} backgroundColor="#e8e8e8" foregroundColor="#f0f0f0" width={385} height={200} viewBox="0 0 385 200"><rect x="0" y="0" rx="10" ry="10" width="385" height="200" /></ContentLoader>
		</div></div>}>
			<Component location={this.props.location} data={this.state.card} className={this.state.card.config.type} />
		</Suspense>
	}

	collapseAlert = () => {
		this.setState({ open: !this.state.open })
	}

	render() {
		const { open, alertData } = this.state;

		return (
			<Fragment>
				<div className={`detail_dashboard dashboard_card_expanded`}>
					<div className="content_detail_dashboard" >
						{alertData && alertData.responseDelete !== undefined && (
							<Collapse in={open}>
								<Grid container spacing={1}>
									<Grid item sm={12}>
										<Alert severity="warning"
											action={
												<IconButton
													aria-label="close"
													color="inherit"
													size="small"
													onClick={this.collapseAlert}
												>
													<CloseIcon fontSize="inherit" />
												</IconButton>
											}
										>
											{alertData.responseDelete}
										</Alert>
										<br />
									</Grid>
								</Grid>
							</Collapse>
						)}
						{alertData && alertData.responseCreate !== undefined && (
							<Collapse in={open}>
								<Grid container spacing={1}>
									<Grid item sm={12}>
										<Alert severity={`${alertData.responseCreate && alertData.responseCreate.detail !== undefined ? 'error' : 'success'}`}
											action={
												<IconButton
													aria-label="close"
													color="inherit"
													size="small"
													onClick={this.collapseAlert}
												>
													<CloseIcon fontSize="inherit" />
												</IconButton>
											}
										>
											{(alertData.responseCreate && alertData.responseCreate.detail !== undefined) ? 'Se produjo un error. Vuelva a intentarlo' : 'Se creó correctamente.'}
										</Alert>
										<br />
									</Grid>
								</Grid>
							</Collapse>
						)}

						{alertData && alertData.responseEdit !== undefined && (
							<Collapse in={open}>
								<Grid container spacing={1}>
									<Grid item sm={12}>
										<Alert severity={`${alertData.responseEdit && alertData.responseEdit.detail !== undefined ? 'error' : 'success'}`}
											action={
												<IconButton
													aria-label="close"
													color="inherit"
													size="small"
													onClick={this.collapseAlert}
												>
													<CloseIcon fontSize="inherit" />
												</IconButton>
											}
										>
											{(alertData.responseEdit && alertData.responseEdit.detail !== undefined) ? 'Se produjo un error. Vuelva a intentarlo' : 'Se editó correctamente.'}
										</Alert>
										<br />
									</Grid>
								</Grid>
							</Collapse>
						)}
						{this.dashboardCardType()}
					</div>
				</div>
			</Fragment>
		)
	}
}

export default withRouter(DashboardCardExpanded);
